import { createSelector } from 'reselect';
import { isUninitialized, isCompleted as isCompleted$1, isFailed as isFailed$1 } from './state.js';

const getCheckout = (state)=>state.checkout
;
const isInitialized = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout)
);
const isCompleted = createSelector(getCheckout, (checkout)=>checkout && isCompleted$1(checkout)
);
const isFailed = createSelector(getCheckout, (checkout)=>checkout && isFailed$1(checkout)
);
const isOrderCreateSuccessFull = createSelector(getCheckout, (checkout)=>checkout && isCompleted$1(checkout) && !!checkout.order
);
/**
 *  Return checkout cart state
 */ const getCartState = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.cartState : undefined
);
/**
 * Routes, selfUrl
 */ const getRoutes = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.routes : undefined
);
const getSelfUrl = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.root ? checkout.root.selfUrl : undefined
);
/**
 * Order - available after completion
 */ const getOrder = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.order ? checkout.order : undefined
);
const getPaymentResponse = createSelector(getOrder, (order)=>order && order.paymentResponse ? order.paymentResponse : undefined
);
const getOrderResponse = createSelector(getOrder, (order)=>order && order.order ? order.order : undefined
);
const getOrderShippingData = createSelector(getOrderResponse, (order)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10;
    return order && {
        billingAddress: order.billingAddress,
        deliveryAddress: order.shippingAddress,
        contactDetails: {
            email: order.customerEmail,
            phone: (ref10 = (ref = order.billingAddress) === null || ref === void 0 ? void 0 : ref.phone) !== null && ref10 !== void 0 ? ref10 : order === null || order === void 0 ? void 0 : (ref1 = order.shippingAddress) === null || ref1 === void 0 ? void 0 : ref1.phone
        },
        company: {
            customerVatId: (ref2 = order.custom) === null || ref2 === void 0 ? void 0 : ref2.fields.customerVatId,
            name: (ref3 = order.billingAddress) === null || ref3 === void 0 ? void 0 : ref3.company,
            secondaryEmail: (ref4 = order.custom) === null || ref4 === void 0 ? void 0 : ref4.fields.secondaryEmail
        },
        invoice: {
            customerCode: (ref5 = order.custom) === null || ref5 === void 0 ? void 0 : ref5.fields.customerCode,
            recipientCode: (ref6 = order.custom) === null || ref6 === void 0 ? void 0 : ref6.fields.recipientCode,
            secureEmail: (ref7 = order.custom) === null || ref7 === void 0 ? void 0 : ref7.fields.secondaryEmail,
            insuranceNumber: (ref8 = order.custom) === null || ref8 === void 0 ? void 0 : ref8.fields.invoiceDetails_insuranceNumber,
            insuranceProvider: (ref9 = order.custom) === null || ref9 === void 0 ? void 0 : ref9.fields.invoiceDetails_insuranceProvider
        }
    };
});
/**
 * Error - available when a critical error occured during checkout
 */ const getError = createSelector(getCheckout, (checkout)=>checkout && isFailed$1(checkout) && checkout.error ? checkout.error : undefined
);
/**
 * Additional cart costs
 */ const getAdditionalCartCosts = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) ? checkout.additionalCosts : undefined
);
/**
 * My account
 */ const getMyAccount = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.myAccount ? checkout.myAccount : undefined
);
const shouldCreateAccount = createSelector(getCheckout, (checkout)=>checkout && !isUninitialized(checkout) && checkout.myAccount ? !!checkout.myAccount.shouldCreateAccount : false
);

export { getAdditionalCartCosts, getCartState, getCheckout, getError, getMyAccount, getOrder, getOrderResponse, getOrderShippingData, getPaymentResponse, getRoutes, getSelfUrl, isCompleted, isFailed, isInitialized, isOrderCreateSuccessFull, shouldCreateAccount };
//# sourceMappingURL=selectors.js.map
